export const SCAN_ASCII_FOR_GROUP_SEPARATOR = 29;
export const FNC_CHAR = String.fromCharCode(SCAN_ASCII_FOR_GROUP_SEPARATOR);
